<template>
  <div>
    <customer-search :get-report="getReport" />
    <template v-if="reportParams.id_customers">
      <report-params :get-report="getReport" />
      <counters />
      <b-row>
        <b-col cols="12">
          <apex-column-chart
            chart-title="Yıllık Ödeme Grafiği"
            chart-sub-title="Alt Başlık"
            :loading="loading"
            :colors-data="['#447c00','#bd2525']"
            :categories-data="reportData.charts.yearly.categories"
            :series-data="reportData.charts.yearly.series"
            :select-options="reportData.params.years"
            :get-data="changeYear"
          />
        </b-col>
        <b-col>
          <latest-payments />
        </b-col>
        <b-col>
          <late-payments />
        </b-col>
        <b-col>
          <pending-payments />
        </b-col>
      </b-row>
    </template>
  </div>
</template>
<script>
import { BRow, BCol } from 'bootstrap-vue'
import CustomerSearch from '@/views/Reports/Customers/components/CustomerSearch.vue'
import ReportParams from '@/views/Reports/Customers/components/ReportParams.vue'
import Counters from '@/views/Reports/Customers/components/Counters.vue'
import LatestPayments from '@/views/Reports/Customers/components/LatestPayments.vue'
import LatePayments from '@/views/Reports/Customers/components/LatePayments.vue'
import PendingPayments from '@/views/Reports/Customers/components/PendingPayments.vue'
import ApexColumnChart from '@/views/Reports/components/ApexColumnChart.vue'

export default {
  name: 'CustomerReportIndex',
  components: {
    BRow,
    BCol,
    CustomerSearch,
    ReportParams,
    Counters,
    LatestPayments,
    LatePayments,
    PendingPayments,
    ApexColumnChart,
  },
  computed: {
    reportParams() {
      return this.$store.getters['reportCustomers/reportParams']
    },
    reportData() {
      return this.$store.getters['reportCustomers/reportData']
    },
    loading() {
      return this.$store.getters['reportCustomers/loading']
    },
  },
  methods: {
    getReport() {
      this.$store.dispatch('reportCustomers/getData', this.reportParams)
    },
    changeYear(year) {
      this.reportParams.year = year
      this.getReport()
    },
  },
}
</script>
